
// Left panel listing all available workflows.
const WorkflowListPanel = ({
  workflows,
  selectedWorkflowCode,
  onSelectWorkflow,
}) => {

  return (

    <div className="ai-workflow-selection">

      {/* Panel heading */}
      <h3>Workflows</h3>

      {/* Workflow list body with empty-state fallback. */}
      <div className="ai-workflow-options">

        {workflows.length === 0 ? (

          /* Empty state when the workflow API returns no options. */
          <p>No workflows available.</p>

        ) : (

          /* Workflow selector buttons. Active button reflects current form workflow. */
          workflows.map((workflow) => (

            <button
              type="button"
              key={workflow.code}
              className={`ai-workflow-option ${selectedWorkflowCode === workflow.code ? "is-active" : ""}`}
              onClick={() => onSelectWorkflow(workflow)}
            >

              <strong>{workflow.name}</strong>

            </button>
          ))
        )}
      </div>

    </div>
  );

};

export default WorkflowListPanel;



